<acabim-datatable [dataSources]="[this]" [dataKey]="'seatId'" [hasDetailView]="false" [hasEditButton]="true"
                  (updateDetail)="onSeatDataChanged($event)"></acabim-datatable>

<acabim-admin-add-organisation-seat [superAdminOverrideOrganisationId]="selectedOrganisation?.id"
                                    (trialRequestCreated)="onNewTrialSeatCreated($event)"></acabim-admin-add-organisation-seat>

<p-toast position="top-right" key="user-subscriptions-view-component"></p-toast>
